export const RESOURCE = 'auth';
export const ACTIONS = { Login: 'login', Logout: 'logout', Refresh: 'refresh' }